/* eslint-disable eqeqeq */
import Vue from 'vue'
import Vuex from 'vuex'
import audio from './modules/audio'
import toB from './modules/toB'
import {
  app
} from '../main'
// import { stat } from 'fs';
Vue.use(Vuex)
// root state object.
// each Vuex instance is just a single state tree.
const state = {
  lang: navigator.language || navigator.userLanguage,
  userDataInfo: JSON.parse(localStorage.getItem('user-info')) || {
    id: null,
    account: '',
    recover: null,
    nickname: '',
    avatar: '',
    source_id: '',
    type: 0,
    email: null,
    sns_account: null,
    points: 0,
    profile_tags: []
  },

  breadcrumb: [
    {
      name: '首頁',
      path: '/'
    },
    {
      name: '',
      path: ''
    },
    {
      name: '',
      path: ''
    }
  ],
  navigatorInfo: [
    {
      title: '首頁',
      to: '/index',
      class: 'home',
      isSelected: true
    },
    {
      title: '品牌故事',
      to: '/story',
      class: 'about',
      isSelected: false
    },
    {
      title: '鯨選課程',
      to: '/channel/list',
      class: 'course',
      isSelected: false
    },
    {
      title: '鯨選大師',
      to: '/author/list',
      class: 'tutor',
      isSelected: false
    },
    // {
    //   title: '部落格',
    //   to: '/blog',
    //   class: 'blog',
    //     isSelected: false
    // },
    // {
    //   title: '探索',
    //   to: '/explore',
    //   class: 'explore',
    //   isSelected: false
    // },
    {
      title: '下載App',
      to: '/app',
      class: 'download',
      isSelected: false
    }
  ],
  myNavigatorInfo: [
    {
      title: '我的帳戶',
      to: '/member/profile',
      class: 'profile',
      isSelected: false
    },
    {
      title: '已購買課程',
      to: '/member/order',
      class: 'order',
      isSelected: false
    },
    {
      title: '訂閱項目',
      to: '/member/subscribe',
      class: 'subscribe',
      isSelected: false
    },
    {
      title: '交易紀錄',
      to: '/member/record',
      class: 'record',
      isSelected: false
    },
    {
      title: '紅包',
      to: '/member/coupon',
      class: 'coupon',
      isSelected: false
    },
    {
      title: '裝置管理',
      to: '/member/device',
      class: 'device',
      isSelected: false
    },
    {
      title: '登出',
      to: '',
      class: 'logout',
      isSelected: false
    }
  ],
  // 本機開發 使用0 , server 1(測試) or 2(正式)
  apiControl: 2, // 0 = server Test , 1 = TEMP , 2 = server Main
  apiControl: process.env.API_ENV, // 0 = server Test , 1 = TEMP , 2 = server Main
  courseId: 0,
  urlDomain: '',
  savePath: '',
  couponState: '',
  isIosMsgShow: 'false',
  userImg: '',
  noticeData: '',

  isMobile: false
  // clientsCID: '',
  // clientId: '',
  // clientTitle: '',
  // clientDescription: '',
  // clientAssets: [],
  // clientsQRCode: '',
  // clientCourses: []

  // editEventId:0,
  // userData:[]
}
const mutations = {
  currentBreadcrumb (state, n) {
    state.breadcrumb = n
  },

  changeUserInfo (state, n) {
    state.userDataInfo = n
  },

  savePath (state, n) {
    this.state.savePath = n
  },
  couponState (state, n) {
    this.state.couponState = n
  },
  isIosMsgShow (state, n) {
    this.state.isIosMsgShow = n
  },
  noticeData (state, n) {
    this.state.noticeData = n
  },

  courseId (state, n) {
    state.courseId = n
  },

  changLocal (state, payload) {
    app.$i18n.locale = payload
    state.lang = payload
  },
  setIsMobile (state, payload) {
    state.isMobile = payload
  }
  // CLIENTS_CID: (state, cid) => {
  //   state.clientsCID = cid
  // },
  // CLIENTS_TITLE: (state, title) => {
  //   state.clientTitle = title
  // },
  // CLIENTS_DESCRIPTION: (state, description) => {
  //   state.clientDescription = description
  // },
  // CLIENTS_ASSETS: (state, assets) => {
  //   state.clientAssets = assets

  //   const coursesIdList = assets.map((clientAsset) => {
  //     return clientAsset.channel.id
  //   })
  //   state.clientCourses = coursesIdList
  // },
  // CLIENTS_QRCODE: (state, QRCode) => {
  //   state.clientsQRCode = QRCode
  // }

}

const actions = {
  setLang ({
    commit
  }, payload) {
    commit('changLocal', payload)
  },
  authLogout: ({
    commit,
    dispatch
  }) => {
    return new Promise((resolve, reject) => {
      const info = {
        id: null,
        account: '',
        recover: null,
        nickname: '',
        avatar: '',
        source_id: '',
        type: 0,
        email: null,
        sns_account: null,
        points: 0,
        profile_tags: []
      }
      commit('changeUserInfo', info)

      localStorage.removeItem('user-token') // clear your user's token from localStorage
      resolve()
    })
  }
}

const getters = {
  baseURL: state => {
    if (state.apiControl == 0) {
      state.urlDomain = 'https://testfront.jinfm.net'
      return 'https://test.jinfm.net/ear/public/api/web/v1/'
    } else if (state.apiControl == 1) {
      state.urlDomain = 'https://tempfront.jinfm.net'
      return 'https://temp.jinfm.net/ear/public/api/web/v1/'
    } else if (state.apiControl == 2) {
      state.urlDomain = 'https://jinfm.net'
      return 'https://prod.jinfm.net/ear/public/api/web/v1/'
    } else if (state.apiControl == 3) {
      state.urlDomain = 'https://testfront.jinfm.net'
      return 'https://dev.jinfm.net/ear/public/api/web/v1/'
    }
  },
  navigators: state => {
    return state.navigatorInfo
  },
  myNavigators: state => {
    return state.myNavigatorInfo
  },
  userInfo: state => {
    return state.userDataInfo
  },
  urlHost: state => {
    return state.urlDomain
  },
  // clientsCID: state => {
  //   return state.clientsCID
  // },
  // clientTitle: state => {
  //   return state.clientTitle
  // },
  // clientLogo: state => {
  //   return state.clientLogo
  // },
  // clientDescription: state => {
  //   return state.clientDescription
  // },
  // clientAssets: state => {
  //   return state.clientAssets
  // },
  // clientCourses: state => {
  //   return state.clientCourses
  // },
  // clientsQRCode: state => {
  //   return state.clientsQRCode
  // },
  // credentialToken:state => {
  //   return state.credentialToken
  // },

  isAuthenticated: state => !!state.userDataInfo.id,
  myModel: state => (state.breadcrumb[1].name === '我的')
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  plugins: [],
  getters,
  actions,
  mutations,
  modules: {
    audio,
    toB
  }

})



// WEBPACK FOOTER //
// ./src/store/index.js